import type { RouteRecordRaw } from 'vue-router'
import AppLogin from '@/pages/Login.vue'
import WebLogin from '@/views/Login.vue'
import { Capacitor } from '@capacitor/core'
import { ROUTES, API_ENDPOINTS } from '@myorg/type-lib'

export const loginRoute: RouteRecordRaw = {
  path: ROUTES.LOGIN.PATH,
  name: ROUTES.LOGIN.NAME,
  component: Capacitor.isNativePlatform() ? AppLogin : WebLogin,
}